import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ACTION_VARIANTS, Button, ICON_NAMES } from '@reverse-hr/design-system';
import type { TChatHeaderProps } from '@components/Molecules/Chat/Chat.types';

export const ChatHeader: FC<TChatHeaderProps> = ({ onToggle }) => {
  const { t } = useTranslation('', {
    keyPrefix: 'candidateDetails.chat',
  });

  return (
    <header className="ev-chat__header">
      <p className="ev-chat__title">{t('header')}</p>

      <Button
        className="ev-chat__full-screen"
        onClick={onToggle}
        rightIcon={ICON_NAMES.CAST}
        variant={ACTION_VARIANTS.SIMPLE_TEXT}
      >
        {t('fullScreenButton')}
      </Button>
    </header>
  );
};
